import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9afbcec2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "pin-instructions" }
const _hoisted_2 = { class: "pin-item" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["innerHTML"]
const _hoisted_5 = { class: "pin-item" }
const _hoisted_6 = ["src"]
const _hoisted_7 = ["innerHTML"]
const _hoisted_8 = { class: "legals" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legals-left" }, null, -1))
const _hoisted_10 = ["innerHTML"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "legals-right" }, null, -1))

import { computed, onMounted, ref } from "vue"
import { gsap } from "gsap"
import { videoStore } from "@/store/modules/Video"
import { resolvePath } from '@/utils/Path'


export default /*#__PURE__*/_defineComponent({
  __name: 'HomePage',
  setup(__props) {

const root = ref<HTMLElement>(null)
const videoPlaying = computed(() => videoStore.play)

onMounted(() => {
  onEnter()
})

const onEnter = () => {
  // const tl = gsap.timeline({ delay: videoPlaying.value ? 1.5 : 0 })
  const tl = gsap.timeline()
  const $ = gsap.utils.selector(root.value)

  tl
    .from($('.pin-item'), {
      scale: 0.5,
      yPercent: -200,
      rotate: () => gsap.utils.random(-60, 60),
      duration: 2,
      ease: 'quart.out',
      stagger: 0.25,
      clearProps: 'all',
      onComplete: (() => $('.pin-item').forEach((el: HTMLElement) => el.style.transition = 'transform 0.5s cubic-bezier(0.55, 0.05, 0.37, 1.01)'))
    })
    .from($('.continue-btn'), {
      scale: 0,
      duration: 0.75,
      ease: 'quart.out',
      clearProps: 'all'
    }, 1)
    .from($('.legals'), {
      scale: 0.9,
      opacity: 0,
      duration: 2,
      ease: 'quart.out',
      clearProps: 'all'
    }, 1.5)
}

return (_ctx: any,_cache: any) => {
  const _component_primary_btn = _resolveComponent("primary-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: "HomePage h-full",
    ref_key: "root",
    ref: root
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("img", {
          src: _unref(resolvePath)(require('@/assets/img/first-instruction.webp')),
          alt: "First instructions"
        }, null, 8, _hoisted_3),
        _createElementVNode("span", {
          innerHTML: _ctx.$t('autorisation.first')
        }, null, 8, _hoisted_4)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("img", {
          src: _unref(resolvePath)(require('@/assets/img/second-instruction.webp')),
          alt: "Second instructions"
        }, null, 8, _hoisted_6),
        _createElementVNode("span", {
          innerHTML: _ctx.$t('autorisation.second')
        }, null, 8, _hoisted_7)
      ])
    ]),
    _createVNode(_component_primary_btn, {
      class: "continue-btn",
      background: "old",
      tag: "router-link",
      to: "/poster"
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.$t('autorisation.btn')), 1)
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_8, [
      _hoisted_9,
      _createElementVNode("p", {
        class: "h4",
        innerHTML: _ctx.$t('autorisation.legal')
      }, null, 8, _hoisted_10),
      _hoisted_11
    ])
  ], 512))
}
}

})